function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m255.997 477.327 47.003-10.847-36.157-36.156z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#4B4B4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "m246.722 446.363 7.777-33.7c.019-.083.047-.161.069-.242.037-.139.074-.278.118-.415s.088-.252.135-.376.088-.234.138-.349c.059-.137.124-.27.19-.4.049-.1.1-.195.151-.29.077-.14.159-.274.243-.408.054-.085.108-.169.165-.252.092-.134.189-.263.289-.39.061-.079.122-.157.186-.233.1-.123.213-.241.323-.357.045-.047.085-.1.131-.144l104.805-104.807c-29.258-60.181-83.362-96-145.442-96-45.522 0-87.578 19.485-118.421 54.865-31.062 35.633-48.565 85.3-49.536 140.291 18.364 9.261 93.769 44.844 167.957 44.844a298.024 298.024 0 0 0 30.722-1.637z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#4B4B4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "m270.461 342.863h176v64h-176z",
  transform: "matrix(.707 -.707 .707 .707 -160.078 363.266)",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#4B4B4B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 216,
  cy: 112,
  r: 80,
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#4B4B4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "m464 301.324a32 32 0 0 0 -54.627-22.624l45.254 45.254a31.785 31.785 0 0 0 9.373-22.63z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#4B4B4B"
}));

var SvgEditProfile = function SvgEditProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-profile.2df2b9a8.svg";
export { ForwardRef as ReactComponent };